import React from 'react';
import { FiActivity, FiCast, FiMap } from "react-icons/fi";
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ServiceList = [
    {
        icon: <FiCast />,
        title: 'Design & Architecture',
        description: 'We combine creativity, technical expertise, and industry knowledge to deliver exceptional design and architectural solutions tailored to your specific needs.'
    },
    {
        icon: <FiMap />,
        title: 'App Development',
        description: 'Fully customized web apps that meet specific business needs. We can ensure excellent performance and reliability for any type of solution.'
    },
    {
        icon: <FiActivity />,
        title: 'Asset Tracking',
        description: 'Our asset tracking services enable businesses to streamline their operations, improve asset utilization, reduce losses or theft, and enhance overall productivity.'
    },
]

const ServiceOne = ({textAlign, serviceStyle}) => {
    return (
        <div className="row row--15 service-wrapper">
              {ServiceList.map( (val , i) => (
                <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                    <ScrollAnimation
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={`service ${serviceStyle} ${textAlign}`}>
                            <div className="icon">
                                {val.icon}
                            </div>
                            <div className="content">
                                <h4 className="title w-600"><Link to="#service" dangerouslySetInnerHTML={{__html: val.title}}></Link></h4>
                                <p className="description b1 color-gray mb--0" dangerouslySetInnerHTML={{__html: val.description}}></p>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default ServiceOne;
